<template>
  <path
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1"
    d="M4 1C4 1 2 2.5 2 6C2 9.5 4 11 4 11"
  />
  <path
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1"
    d="M8 1C8 1 10 2.5 10 6C10 9.5 8 11 8 11"
  />
</template>
